// extracted by mini-css-extract-plugin
module.exports = {"ModalPaper":"withErrorHandler_ModalPaper__7uwIC","ModalStyle":"withErrorHandler_ModalStyle__1dAeY"};